<template>
    <footer>
        <article class="footer_wrap">
            <a aria-label="전화번호 안내로 이동합니다." role="button" href="javascript:void(0);" @click="telPopupShow">전화번호 안내</a>
            <span aria-hidden="true" tabindex="-1"> | </span>
            <a aria-label="개인정보 취급방침 안내로 이동합니다." role="button" href="javascript:void(0);" @click="pageLink(2)">개인정보취급방침</a>
            <span aria-hidden="true" tabindex="-1"> | </span>
            <a aria-label="이용자 준수사항 안내로 이동합니다." role="button" href="javascript:void(0);" @click="pageLink(3)">이용자준수사항</a>
            <!--span> | </span>
            <a href="javascript:void(0);" @click="memberRegist()">이용신청서</a-->
            <a aria-label="서울시각장애인 생활 이동지원센터 메인페이지로 이동합니다." role="button" class="footer_logo" href="javascript:void(0);" @click="main"><img aria-hidden="true" src="../../assets/images/img_logo_w.png" alt="서울특별시 서울시각장애인 생활이동지원센터 로고" /></a>
            <p aria-label="주소는 서울특별시 동작구 상도로216 (인경빌딩 3, 4층)입니다. 현재 웹사이트는 2018년부터 서울시각장애인 생활 이동지원센터에서 모든 권리를 보유하고 있습니다.">
            서울특별시 동작구 상도로216 (인경빌딩 3, 4층)<br />
            Copyright ⓒ 2018 kbucall. All Right Reserved.
            </p>
            <div class="ma_wrap" >
                <a role="img" aria-label="한국웹접근성평가센터 모바일 접근성 품질인증마크 입니다." href="javascript:void(0)" >
                    <img aria-hidden="true" src="../../assets/images/MA.png" alt="한국웹접근성평가센터 모바일 접근성 품질인증마크" />
                </a>
            </div>
        </article> 
    </footer>
</template>

<script>
export default {
    methods: {
        telPopupShow() {
            this.$emit('telPopupShow');
            window.scrollTo(0, 0);
        },
        pageLink(contents_no) {
            this.$router.push('/m/contents/'+contents_no);
        },
        main() {
            this.$router.push('/m');
        },
        memberRegist() {
            this.$router.push('/m/member/regist');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/common/Footer.vue